import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  ListItem,
  ListItemText,
  Typography,
  Tooltip,
  IconButton,
  Box,
  ListItemIcon,
} from '@mui/material';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import ReplyIcon from '@mui/icons-material/Reply';
import removeImgsFromBody from '../../Helpers/StringsFormatting/removeImgsFromBody';
import { formatListItemDate } from '../../Helpers/dates';
import { ColumnFlexBox, FlexBox } from '../FlexBox';
import { EditRounded } from '@mui/icons-material';
import OutcomeDialog from './OutcomeDialog';
import { compareDates } from '../../Helpers/dates';
import Chip from '../Chip';
import capitalize from '../../Helpers/StringsFormatting/capitalize';
function Activity({
  isCustomerPage = false,
  openReply = null,
  data,
  campaignId,
  activityData,
  handleOpenDetailsDialog,
  withoutOutcome = false,
  selectedCustomer,
  recall = false,
  isOperator = false,
}) {
  const intl = useIntl();
  const [outcomeDialog, setOutcomeDialog] = useState(false);
  const {
    id,
    activityType,
    icon,
    primaryTxt,
    from,
    to,
    dateTime,
    scheduledIcon,
    content,
    campaignAdvancement,
    commercialCampaignId,
    notPerformed,
  } = activityData;

  function createHTML() {
    const notesWithoutImages = removeImgsFromBody(content);
    return { __html: notesWithoutImages };
  }

  const handleOpenOutcomeDialog = () => {
    setOutcomeDialog(true);
  };
  const handleCloseOutcomeDialog = () => {
    setOutcomeDialog(false);
  };

  return (
    <>
      <OutcomeDialog
        callId={id}
        selectedCustomer={selectedCustomer}
        open={outcomeDialog}
        onClose={handleCloseOutcomeDialog}
        isOperator={isOperator}
        campaignId={commercialCampaignId || campaignId}
      />
      <ListItem
        sx={{ minHeight: '80px' }}
        divider
        slotProps={{}}
        secondaryAction={
          <ColumnFlexBox alignItems="flex-end">
            <Typography
              variant="overline"
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.80rem',
                opacity: notPerformed ? 0.6 : 1,
              }}
            >
              <Tooltip title={intl.messages.SCHEDULED} arrow placement="top">
                {scheduledIcon}
              </Tooltip>
              {formatListItemDate(dateTime, Boolean(selectedCustomer))}
            </Typography>

            {isCustomerPage && (
              <div>
                <Tooltip
                  title={
                    activityType === 'EMAIL' || activityType === 'SMS'
                      ? intl.messages.SHOW_CONTENTBODY
                      : content
                        ? intl.messages.SHOW_NOTES
                        : intl.messages.ADD_NOTES
                  }
                  placement="bottom"
                >
                  {!notPerformed && (
                    <IconButton
                      onClick={() =>
                        handleOpenDetailsDialog({
                          activityId: id,
                          activityType,
                        })
                      }
                    >
                      <TextSnippetOutlinedIcon
                        sx={{ color: content && 'primary.main' }}
                      />
                    </IconButton>
                  )}
                </Tooltip>
                {activityType === 'EMAIL' && (
                  <Tooltip title={intl.messages.REPLY} placement="bottom">
                    <IconButton onClick={() => openReply(data)}>
                      <ReplyIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            )}
          </ColumnFlexBox>
        }
      >
        <ListItemIcon sx={{ opacity: notPerformed ? 0.6 : 1 }}>
          {icon || <ViewStreamIcon size="large" />}
        </ListItemIcon>
        <ListItemText
          disableTypography
          primary={
            <FlexBox alignItems="center" gap={1} width={'80%'}>
              <Typography
                variant="body1"
                noWrap
                sx={{ opacity: notPerformed ? 0.6 : 1 }}
              >
                {recall
                  ? !data.completedOn &&
                    compareDates(
                      new Date(data?.scheduledOn ?? null),
                      new Date(),
                      'smaller'
                    )
                    ? intl.messages.UNCOMPLETED_RECALL
                    : intl.messages.SCHEDULED_RECALL
                  : capitalize(primaryTxt) || intl.messages.UNAVAILABLE}
              </Typography>
              {withoutOutcome && isCustomerPage && activityType === 'CALL' && (
                <Tooltip title={intl.messages.SET_OUTCOME} placement="bottom">
                  <IconButton onClick={handleOpenOutcomeDialog}>
                    <EditRounded />
                  </IconButton>
                </Tooltip>
              )}
              {campaignAdvancement ? (
                <Chip
                  id={`${id}-call-percentage`}
                  variant="outlined"
                  label={`${campaignAdvancement}%`}
                  color="#1D5B9D"
                  height="unset"
                />
              ) : null}
            </FlexBox>
          }
          secondary={
            <Box
              sx={{
                display: "flex",
                flexDirection: "column"
              }}>
              <Typography
                variant="subtitle2"
                noWrap
                sx={{ width: '80%', opacity: notPerformed ? 0.6 : 1 }}
              >
                {from
                  ? `${intl.messages.FROM} ${from || intl.messages.UNAVAILABLE}`
                  : null}
              </Typography>
              <Typography
                variant="subtitle2"
                noWrap
                sx={{ width: '80%', opacity: notPerformed ? 0.6 : 1 }}
              >
                {to
                  ? `${intl.messages.TO} ${to || intl.messages.UNAVAILABLE}`
                  : null}
              </Typography>
              <Typography
                variant="body2"
                noWrap
                sx={{
                  width: '80%',
                  div: {
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                  },
                }}
                dangerouslySetInnerHTML={createHTML()}
              />
            </Box>
          }
        />
      </ListItem>
    </>
  );
}

Activity.propTypes = {
  isCustomerPage: PropTypes.bool,
  data: PropTypes.object.isRequired,
  activityData: PropTypes.object.isRequired,
  icon: PropTypes.object,
  handleOpenDetailsDialog: PropTypes.func.isRequired,
  openReply: PropTypes.func,
};

export default Activity;
